import React from 'react';
import { SecondaryText } from '@brokerbay/design-components';
import styled from 'styled-components';
import { Icon, Space, theme } from 'components';
import { Text } from 'components/Typography/Text';

interface TourRouteStopItemProps {
  locationName?: string;
  address?: string;
  isMobile?: boolean;
}

const TourRouteStopItem: React.FC<TourRouteStopItemProps> = ({
  locationName,
  address,
  isMobile,
}) => (
  <div>
    <StyledSpace align="center" size={12}>
      <StyledMapPin isMobile={isMobile}>
        <Icon type="pin" width={22} color="gray7" />
      </StyledMapPin>
      <StyledTextContainer>
        <Text>{locationName}</Text>
        <SecondaryText>{address}</SecondaryText>
      </StyledTextContainer>
    </StyledSpace>
  </div>
);

export default TourRouteStopItem;

const StyledSpace = styled(Space)`
  & div {
    z-index: 100;
  }
`;

const StyledMapPin = styled.div<{ isMobile?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${({ isMobile }) => (isMobile ? '0' : '24px')};
  border-radius: 4px;
  background-color: #f0f0f0;
  width: 40px;
  height: 40px;
  background-color: ${theme.gray5};
`;

const StyledTextContainer = styled.div`
  line-height: 1.5;
  display: flex;
  flex-direction: column;
`;
